import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice";
import { authApi } from "../features/api/authApi";
import { courseApi } from "../features/api/courseApi";
import { pageApi } from "../features/api/pageApi";
import { postApi } from "../features/api/postApi";
import { newsFlashApi } from "../features/api/newsFlashApi"; 
import { supportApi } from "../features/api/supportApi"; 
import { leadApi } from "@/features/api/leadsApi";
import { invoiceApi } from "@/features/api/invoiceApi";
import {orderApi} from "@/features/api/orderApi";
import {partnersApi} from "@/features/api/partnersApi";
import { subscriptionApi } from '@/features/api/subscriptionAPi';
import { contactApi } from "@/features/api/contactApi";
import { profileApi } from "@/features/api/profileApi";
import { mockTestApi } from "@/features/api/mockTestApi";



// Combine reducers for both API slices and custom reducers
const rootReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,  // Auth API reducer
  [courseApi.reducerPath]: courseApi.reducer,  // Course API reducer
  [pageApi.reducerPath]: pageApi.reducer,  // Pages API reducer
  [postApi.reducerPath]: postApi.reducer,
  [newsFlashApi.reducerPath]: newsFlashApi.reducer,
  [supportApi.reducerPath]: supportApi.reducer,
  [leadApi.reducerPath]: leadApi.reducer, 
  [invoiceApi.reducerPath]: invoiceApi.reducer, 
  [orderApi.reducerPath]: orderApi.reducer,
  [partnersApi.reducerPath]: partnersApi.reducer,
  [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  [contactApi.reducerPath]: contactApi.reducer,
  [profileApi.reducerPath]: profileApi.reducer,
  [mockTestApi.reducerPath]: mockTestApi.reducer,



  auth: authReducer  // Custom auth reducer for user state
});

export default rootReducer;
